export const createJob = `
  mutation CreateJob($input: CreateJobInput!) {
    createJob(input: $input) {
      job {
        jobId
        name
        tenantId
        username
        cognitoSub
        jobType
        status
        documentProcessingStatus
        documentVerificationStatus
        investorGuidelineReviewStatus
        loanCount
        processedLoanCount
        verifiedDocumentCount
        totalDocumentCount
        guidelineCheckCount
        totalGuidelineCount
        createdAt
        uploadLocation
        loans {
          loanId
          jobId
          loanNumber
          borrowerName
          propertyAddress
          loanAmount
          coBorrowerNames
          status
          createdAt
        }
      }
      uploadBucket
      uploadPrefix
    }
  }
`;

export const createLoan = `
  mutation CreateLoan($input: CreateLoanInput!) {
    createLoan(input: $input) {
      loanId
      jobId
      tenantId
      username
      cognitoSub
      loanNumber
      borrowerName
      propertyAddress
      loanAmount
      fileCount
      status
      createdAt
    }
  }
`;

export const submitJob = `
  mutation SubmitJob($input: SubmitJobInput!) {
    submitJob(input: $input) {
      jobId
      status
      s3Uri
      message
    }
  }
`;

export const updateJobStatus = `
  mutation UpdateJobStatus($jobId: ID!, $tenantId: String!, $status: JobStatus!, $startedAt: AWSDateTime, $completedAt: AWSDateTime, $processedLoanCount: Int, $failedLoanCount: Int) {
    updateJobStatus(jobId: $jobId, tenantId: $tenantId, status: $status, startedAt: $startedAt, completedAt: $completedAt, processedLoanCount: $processedLoanCount, failedLoanCount: $failedLoanCount) {
      jobId
      status
      startedAt
      completedAt
      processedLoanCount
      failedLoanCount
    }
  }
`;

export const updateLoanStatus = `
  mutation UpdateLoanStatus($loanId: ID!, $jobId: ID!, $tenantId: String!, $status: LoanStatus!, $startedAt: AWSDateTime, $completedAt: AWSDateTime, $processedFileCount: Int, $failedFileCount: Int) {
    updateLoanStatus(loanId: $loanId, jobId: $jobId, tenantId: $tenantId, status: $status, startedAt: $startedAt, completedAt: $completedAt, processedFileCount: $processedFileCount, failedFileCount: $failedFileCount) {
      loanId
      jobId
      status
      startedAt
      completedAt
      processedFileCount
      failedFileCount
    }
  }
`;

export const updateJobName = `
  mutation UpdateJobName($jobId: ID!, $tenantId: String!, $name: String!) {
    updateJobName(jobId: $jobId, tenantId: $tenantId, name: $name) {
      jobId
      name
      tenantId
      username
      cognitoSub
      loanCount
      uploadLocation
      exportLocation
      status
      createdAt
      startedAt
      completedAt
      processedLoanCount
      failedLoanCount
    }
  }
`;

export const updateLoanInfo = `
  mutation UpdateLoanInfo($loanId: ID!, $jobId: ID!, $tenantId: String!, $loanNumber: String, $borrowerName: String, $propertyAddress: String, $loanAmount: String) {
    updateLoanInfo(loanId: $loanId, jobId: $jobId, tenantId: $tenantId, loanNumber: $loanNumber, borrowerName: $borrowerName, propertyAddress: $propertyAddress, loanAmount: $loanAmount) {
      loanId
      jobId
      loanNumber
      borrowerName
      propertyAddress
      loanAmount
    }
  }
`;

export const createFile = `
  mutation CreateFile($input: CreateFileInput!) {
    createFile(input: $input) {
      fileId
      loanId
      jobId
      filename
      fileSize
      s3Key
      status
      createdAt
    }
  }
`;

export const updateFile = `
  mutation UpdateFile($input: UpdateFileInput!) {
    updateFile(input: $input) {
      fileId
      loanId
      jobId
      status
      pageCount
      splitDocumentCount
      processedAt
      errorMessage
    }
  }
`;

export const createDocument = `
  mutation CreateDocument($input: CreateDocumentInput!) {
    createDocument(input: $input) {
      documentId
      fileId
      loanId
      jobId
      sourceFilename
      pageRange
      status
      createdAt
    }
  }
`;

export const updateDocument = `
  mutation UpdateDocument($input: UpdateDocumentInput!) {
    updateDocument(input: $input) {
      documentId
      fileId
      loanId
      jobId
      documentType
      confidenceScore
      requiresHumanReview
      processedDataS3Key
      processedAt
      reviewTaskARN
      errorMessage
    }
  }
`;

export const deleteJob = `
  mutation DeleteJob($jobId: ID!, $tenantId: String!) {
    deleteJob(jobId: $jobId, tenantId: $tenantId) {
      jobId
      message
    }
  }
`;


export const deleteFile = `
  mutation DeleteFile($fileId: ID!, $loanId: ID!, $jobId: ID!, $tenantId: String!, $s3Key: String) {
    deleteFile(fileId: $fileId, loanId: $loanId, jobId: $jobId, tenantId: $tenantId, s3Key: $s3Key) {
      fileId
      loanId
      jobId
      message
    }
  }
`;


export const deleteDocument = `
  mutation DeleteDocument($documentId: ID!, $fileId: ID!, $loanId: ID!, $jobId: ID!, $tenantId: String!) {
    deleteDocument(documentId: $documentId, fileId: $fileId, loanId: $loanId, jobId: $jobId, tenantId: $tenantId) {
      documentId
      fileId
      loanId
      jobId
      message
    }
  }
`;

export const finalizeDocumentReview = `
  mutation FinalizeDocumentReview($input: FinalizeDocumentReviewInput!) {
    finalizeDocumentReview(input: $input) {
      fileId
      loanId
      jobId
      status
    }
  }
`;

// ============================================
// Step Status Mutations
// ============================================

export const updateStepStatus = `
  mutation UpdateStepStatus($input: UpdateStepStatusInput!) {
    updateStepStatus(input: $input) {
      jobId
      name
      tenantId
      username
      cognitoSub
      jobType
      status
      documentProcessingStatus
      documentVerificationStatus
      investorGuidelineReviewStatus
      findingsDisplayStatus
      loanCount
      processedLoanCount
      verifiedDocumentCount
      totalDocumentCount
      guidelineCheckCount
      totalGuidelineCount
      createdAt
      startedAt
      completedAt
    }
  }
`;

export const completeStep = `
  mutation CompleteStep($jobId: ID!, $tenantId: String!, $step: StepType!, $jobType: JobType) {
    completeStep(jobId: $jobId, tenantId: $tenantId, step: $step, jobType: $jobType) {
      jobId
      name
      tenantId
      username
      cognitoSub
      jobType
      status
      documentProcessingStatus
      documentVerificationStatus
      investorGuidelineReviewStatus
      loanCount
      processedLoanCount
      verifiedDocumentCount
      totalDocumentCount
      guidelineCheckCount
      totalGuidelineCount
      createdAt
      startedAt
      completedAt
    }
  }
`;

export const submitDocumentsForProcessing = `
  mutation SubmitDocumentsForProcessing($input: SubmitDocumentsForProcessingInput!) {
    submitDocumentsForProcessing(input: $input) {
      jobId
      name
      tenantId
      username
      cognitoSub
      jobType
      status
      documentProcessingStatus
      documentVerificationStatus
      investorGuidelineReviewStatus
      loanCount
      processedLoanCount
      verifiedDocumentCount
      totalDocumentCount
      guidelineCheckCount
      totalGuidelineCount
      createdAt
      startedAt
      completedAt
    }
  }
`;

export const submitVerification = `
  mutation SubmitVerification($input: SubmitVerificationInput!) {
    submitVerification(input: $input) {
      jobId
      name
      tenantId
      username
      cognitoSub
      jobType
      status
      documentProcessingStatus
      documentVerificationStatus
      investorGuidelineReviewStatus
      loanCount
      processedLoanCount
      verifiedDocumentCount
      totalDocumentCount
      guidelineCheckCount
      totalGuidelineCount
      createdAt
      startedAt
      completedAt
    }
  }
`;

export const submitGuidelineAnalysis = `
  mutation SubmitGuidelineAnalysis($input: SubmitGuidelineAnalysisInput!) {
    submitGuidelineAnalysis(input: $input) {
      jobId
      name
      tenantId
      username
      cognitoSub
      jobType
      status
      documentProcessingStatus
      documentVerificationStatus
      investorGuidelineReviewStatus
      loanCount
      processedLoanCount
      verifiedDocumentCount
      totalDocumentCount
      guidelineCheckCount
      totalGuidelineCount
      createdAt
      startedAt
      completedAt
    }
  }
`;

export const submitGuidelineReview = `
  mutation SubmitGuidelineReview($input: SubmitGuidelineReviewInput!) {
    submitGuidelineReview(input: $input) {
      jobId
      message
    }
  }
`;

export const saveModelConfig = `
  mutation SaveModelConfig($input: SaveModelConfigInput!) {
    saveModelConfig(input: $input)
  }
`;
